import Div from "@jumbo/shared/Div";
import { Button, InputAdornment, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ListUnitTable from "./unitTable";
import { useDispatch } from "react-redux";
import { getAllUnit } from "app/redux/actions/masterAction";

export default function ListUnit() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  const handleSearch = (value) => {
    dispatch(getAllUnit(value));
  };
  useEffect(() => {
    dispatch(getAllUnit("",1));
  }, []);
  return (
    <Div sx={{ mt: -4 }}>
      <Typography variant="h1">Unit Master</Typography>
      <Div
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <TextField
          size="small"
          id="search"
          type="search"
          label="Search"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            handleSearch(e.target.value);
          }}
          sx={{ width: 300, mb: 5, mt: 4 }}
          InputProps={{
            endAdornment: (
              <Div sx={{ cursor: "pointer" }} onClick={handleSearch}>
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              </Div>
            ),
          }}
        />
        {permissions?.unit_master_create == true && (
          <Div>
            <Button
              variant="contained"
              sx={{ p: 1, pl: 4, pr: 4 }}
              onClick={() => navigate("/master/unit/add")}
            >
              Add New Unit
            </Button>
          </Div>
        )}
      </Div>
      <ListUnitTable />
    </Div>
  );
}
